import React from "react";
import styled from "styled-components";
import { useAuth, hasRole } from "../../context/AuthContext";
import AuthGate from "../AuthGate";

const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
`;

const ProtectedRoute = ({ requiredRole = "public", preview = null, children }) => {
  const { role, loading } = useAuth();

  if (loading) {
    return <SpinnerWrap>Loading…</SpinnerWrap>;
  }

  if (!hasRole(role, requiredRole)) {
    return <AuthGate requiredRole={requiredRole}>{preview}</AuthGate>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
